// extracted by mini-css-extract-plugin
module.exports = {"item":"footer_item-module__item--1XtXL"};